import {useReviewsTotal} from 'modules/products/hooks/useReviewsTotal';
import {useMemo} from 'react';
import {REVIEWS_CODE} from 'modules/product-card/constants';
import {useRouter} from 'next/router';
import {IRating} from 'modules/products/types';

export const useReviewsMeta = (ratings?: IRating[]) => {
    const {query} = useRouter();
    const total = useReviewsTotal({code: query.code as string});
    const reviewRating = useMemo(() => {
        return ratings?.find(({code}) => REVIEWS_CODE === code)?.value ?? 0;
    }, [ratings]);
    const ratingValues = total.assessments
        .filter((item) => 0 < item.count)
        .sort((a, b) => (a.count < b.count ? 1 : -1));
    // const bestRating = ratingValues.length ? ratingValues[0]?.title : 5;
    const bestRating = 5;
    // const worstRating = 0 < ratingValues.length ? ratingValues[ratingValues.length - 1].title : 1;
    const worstRating = 1;

    return {
        total,
        reviewRating,
        ratingValues,
        bestRating,
        worstRating,
    };
};
